import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Button, Spin } from 'antd';
import { Modal, Icon } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import 'moment-timezone';
import * as SignalR from '@aspnet/signalr';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'loginStore',
    'webSettingStore',
    'TransactionStore',
    'CmsPaymentTypeStore',
    'CmsPaymentStore',
    'PaymentLogStore'
)
@observer
class FnbSuccessPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData();
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    back = () => {
        this.props.history.push('/');
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;
        const { data: webSettting } = this.props.webSettingStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <>
                                                <Content>
                                                    {/* Header */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {webSettting.orderPopupTitleText}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    {/* Body */}
                                                    <Row className='stm-margin-top-50 stm-padding-bottom-100 stm-background-white'>
                                                        <Col span={1} />
                                                        <Col span={22}>
                                                            <Row>
                                                                <Col span={24}
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                        color: activeTemplate.templateSetting.text.color,
                                                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                        textAlign: 'center',
                                                                        marginTop: 32
                                                                    }}>
                                                                        {webSettting.orderPopupSuccessText}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={1} />
                                                    </Row>

                                                    {/* Confirm */}
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                                        >
                                                            <Row>
                                                                <Col span={1} />
                                                                <Col span={22} >
                                                                    <Button
                                                                        className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                                                        style={{
                                                                            background: activeTemplate.templateSetting.footer.backgroundColor,
                                                                            fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                                            fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.footer.fontSize + 2}px`,
                                                                            color: activeTemplate.templateSetting.footer.color
                                                                        }}
                                                                        onClick={() => this.props.history.push('/order')}
                                                                    >
                                                                        {webSettting.goToOrderText}
                                                                    </Button>
                                                                </Col>
                                                                <Col span={1} />
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Content>
                                            </>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(FnbSuccessPage)